module.exports = __webpack_public_path__ + "static/media/kit_justcast.6b5d2772.png";